import * as React from "react";
import Dropdown from "../../Dropdown/Dropdown";
import Input from "../../Input-new/Input";
import Checkbox from "../../CheckboxNew";
import Tags from "../../Tags/Tags";
import {Link} from "react-router";
import { getTenantSubcategoryMT, getTenantSubcategorySTNL, convertDateTimeFormatToDate } from "../../../utils";
import { dateToUsString } from "../../../date-converter";
import UploadFiles from "./UploadFiles";
import Textarea from "../../Textarea-new/Textarea";
import { formatDateUSA } from "../../../utils";
import { isFieldLocked } from "../../../access-levels";
import { can } from "../../../access";
import LoanBids from "../../LoanBids/LoanBids";
import { showOnPropertyTab } from "../../LoanBids/visibility";
import ParcelMapLink from "../../ParcelMapLink";

const items = [{
    label:'Marketing Package',
    name:'MEDIA_KIT'
}];

const fileTypes = {
    Document: 'file',
    Photo: 'photo'
};

const photos = [{
    label: 'Photo 1',
    name: 'WEBSITE_PHOTO_1',
}, {
    label: 'Photo 2',
    name: 'WEBSITE_PHOTO_2',
}, {
    label: 'Photo 3',
    name: 'WEBSITE_PHOTO_3',
}, {
    label: 'Photo 4',
    name: 'WEBSITE_PHOTO_4',
}, {
    label: 'Photo 5',
    name: 'WEBSITE_PHOTO_5',
}];

const PropertyInfo = ({data, account, handleChangeDropdown, handleChangeInput, handleChangeFile, getTenantsForTags, viewMode, deleted, isReferral, isFinancing, isStriveFinancing, redirectToHscTracking, isOffMarket = false, ownDealsOnly, isExtraPayment, onShowNotes, notes, zipLoading, locks, showLoanBids }) => {
    const isSaleLeaseBack = data.SALE_LEASE_BACK === 'Yes';
    let COE;
    if (isSaleLeaseBack && data.CLOSE_OF_ESCROW && data.ORIGINAL_LEASE_TERM) {
        COE = new Date(data.CLOSE_OF_ESCROW);
        COE.setFullYear(COE.getFullYear()+parseInt(data.ORIGINAL_LEASE_TERM))
        const ledYear= COE.getFullYear();
        const lcdYear= new Date(data.CLOSE_OF_ESCROW).getFullYear();
        let year = ledYear ||  lcdYear;      
        if(ledYear <lcdYear){
            year = lcdYear;
        }          
        let month = COE.getMonth();
        var lastDay = new Date(year, COE.getMonth(), 0).getDate();
        if(COE.getDate()>14){      
            month = month+2;
            if(month==13){
                month=1;
                year = year+1;
            }
            
            lastDay = new Date(year, COE.getMonth() + 2, 0).getDate();
        }else{
            if(month<1){
                month=12;
                year = year-1;
            }
        }
        const _value = month+"/"+lastDay+"/"+year;
        COE = dateToUsString(new Date(_value));
    }

    React.useEffect(() => {
        if (data.TYPE !== 'STNL' || data.SALE_LEASE_BACK !== 'Yes' || !data.CLOSE_OF_ESCROW || !handleChangeInput) return;
        const hasCommencement = data.LEASE_COMMENCEMENT_DATE;
        const hasExpiration = data.LEASE_EXPIRATION_DATE;
        if (hasCommencement && hasExpiration) return;
        const commencement = convertDateTimeFormatToDate(data.CLOSE_OF_ESCROW) || data.CLOSE_OF_ESCROW;
        if (!hasCommencement) handleChangeInput('LEASE_COMMENCEMENT_DATE', commencement);
        if (!hasExpiration && data.ORIGINAL_LEASE_TERM) {
            let expDate = new Date(data.CLOSE_OF_ESCROW);
            expDate.setFullYear(expDate.getFullYear() + parseInt(data.ORIGINAL_LEASE_TERM));
            const ledYear = expDate.getFullYear();
            const lcdYear = new Date(data.CLOSE_OF_ESCROW).getFullYear();
            let year = ledYear || lcdYear;
            if (ledYear < lcdYear) year = lcdYear;
            let month = expDate.getMonth();
            let lastDay = new Date(year, expDate.getMonth(), 0).getDate();
            if (expDate.getDate() > 14) {
                month = month + 2;
                if (month === 13) { month = 1; year = year + 1; }
                lastDay = new Date(year, expDate.getMonth() + 2, 0).getDate();
            } else {
                if (month < 1) { month = 12; year = year - 1; }
            }
            const expValue = month + "/" + lastDay + "/" + year;
            handleChangeInput('LEASE_EXPIRATION_DATE', dateToUsString(new Date(expValue)));
        }
    }, [data.TYPE, data.SALE_LEASE_BACK, data.CLOSE_OF_ESCROW, data.ORIGINAL_LEASE_TERM, data.LEASE_COMMENCEMENT_DATE, data.LEASE_EXPIRATION_DATE]);
    
    return (
        
        <div className="Property-info">
            <div className="Property-info_column">
                <div className="property-name-section">
                    <label className="Property-info_property-name-label">
                        Property Name
                        {!isExtraPayment && (
                            <React.Fragment>
                                <Checkbox
                                    text="HOT LIST"
                                    type={viewMode || isFieldLocked(locks, "HOT_LIST") ? "uncheckable" : "checkable"}
                                    isSelected={data.HOT_LIST}
                                    handleClick={handleChangeInput}
                                    name="HOT_LIST"
                                />
                                <Checkbox
                                    text="NEW DEVELOPMENT"
                                    type={viewMode || isFieldLocked(locks, "NEW_DEVELOPMENT") ? "uncheckable" : "checkable"}
                                    isSelected={data.NEW_DEVELOPMENT}
                                    handleClick={handleChangeInput}
                                    name="NEW_DEVELOPMENT"
                                />
                            </React.Fragment>
                        )}
                    </label>
                    <Input
                        className="Property-info_column_item"
                        required
                        valueType="text"
                        name="NAME"                        
                        value={
                            viewMode && data.MEDIA_KIT ?
                                <Link className="green" target='_blank' to={arc.path.media + data.MEDIA_KIT}>
                                    {data.NAME}
                                </Link>
                            :
                                data.NAME
                        }
                        disabled={isFieldLocked(locks, "NAME")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                </div>
                
                {   
                    !isExtraPayment && <div>
                <Input
                    className="Property-info_column_item"
                    valueType="text"
                    name="ADDRESS"
                    required={ownDealsOnly ? true : false}
                    label="Address"
                    value={
                        viewMode ?
                            <ParcelMapLink className="green" property={data}>
                                {data.ADDRESS}
                            </ParcelMapLink>
                            :
                            data.ADDRESS
                    }
                    disabled={isFieldLocked(locks, "ADDRESS")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                /></div>}
                {/* {
                    !isExtraPayment &&
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="STREET"
                        label="Street"
                        value={data.STREET}
                        disabled={isFieldLocked(locks, "STREET")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                } */}
                { !isExtraPayment && <div style={{ position: 'relative' }}>
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="ZIP"
                        label="Zip"
                        value={data.ZIP}
                        required={ownDealsOnly ? true : false}
                        disabled={isFieldLocked(locks, "ZIP")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    {zipLoading && <span style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50)', fontSize: '12px', color: '#888' }}>Loading...</span>}
                </div>
                }
                <Input
                    className="Property-info_column_item"
                    valueType="text"
                    name="CITY"
                    required={ownDealsOnly ? true : false}
                    label="City"
                    value={data.CITY}
                    disabled={isFieldLocked(locks, "CITY")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    value={data.STATE}
                    valueKey="STATE"
                    label="State"
                    required={ownDealsOnly ? true : false}
                    disabled={isFieldLocked(locks, "STATE")}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                /> 
                {
                    !isReferral && !isOffMarket && !isExtraPayment &&
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="YEAR_BUILT"
                        label="Year Built"
                        value={data.YEAR_BUILT}
                        disabled={isFieldLocked(locks, "YEAR_BUILT")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                {
                    !isReferral && !isOffMarket  && !isExtraPayment &&
                    <Input
                        className="Property-info_column_item"
                        valueType="integer"
                        name="SQFT"
                        label="Square Feet"
                        value={data.SQFT}
                        disabled={isFieldLocked(locks, "SQFT")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        withCommas
                    />
                }
                {
                    !isExtraPayment && !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="float"
                        name="ACRES"
                        label="Acres"
                        value={data.ACRES}
                        disabled={isFieldLocked(locks, "ACRES")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        decimals={2}
                    />
                }
                {
                    !isExtraPayment &&
                    <Textarea
                        className="Property-info_column_item"
                        theme='white'
                        name='NOTES'
                        label={`Notes`}  
                        value={notes && notes.length > 0 ? `${formatDateUSA(notes[0].DATE_CREATED)}: ${notes[0].NOTE_TEXT}` : ''}
                        maxWidth='100%'
                        viewMode={true}
                        handleParentChange={handleChangeInput}
                    />

                }
                {
                    !isExtraPayment &&
                    <div className="Property-info_column_item Property-info-notes-button-wrap">
                        <button
                            type="button"
                            className="Property-info-show-notes-btn"
                            onClick={onShowNotes}
                        >
                            Show Notes
                        </button>
                    </div>
                }
            </div>
            <div className="Property-info_column">
                {
                    isOffMarket &&
                    <Dropdown
                        optionKey='code'
                        className="Property-info_column_item"
                        data={data}
                        isFromProperty
                        optionsType="status"
                        value={data.STATUS}
                        valueKey="STATUS"
                        label="Status"
                        disabled={isFieldLocked(locks, "STATUS")}
                        handleParentChange={handleChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                        isOffMarket={true}
                    />
                }
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="source"
                    value={data.SOURCE}
                    required={ownDealsOnly ? true : false}
                    valueKey="SOURCE"
                    label="Source"
                    disabled={isFieldLocked(locks, "SOURCE")}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Dropdown
                    className="Property-info_column_item"
                    data={data}
                    isFromProperty
                    optionsType="transaction"
                    required={ownDealsOnly ? true : false}
                    value={data.TRANSACTION_TYPE}
                    valueKey="TRANSACTION_TYPE"
                    label="Transaction Type"
                    disabled={isFieldLocked(locks, "TRANSACTION_TYPE")}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                {
                    !isExtraPayment &&
                    <Dropdown
                        className="Property-info_column_item"
                        data={data}
                        isFromProperty
                        optionsType="market"
                        optionLabelKey='name'
                        optionKey='code'
                        value={data.MARKET}
                        required={ownDealsOnly ? true : false}
                        valueKey="MARKET"
                        label="Market"
                        disabled={isFieldLocked(locks, "MARKET")}
                        handleParentChange={handleChangeDropdown}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                {
                    !isExtraPayment && !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="COUNTY"
                        label="County"
                        value={data.COUNTY}
                        disabled={isFieldLocked(locks, "COUNTY")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                {
                    !isExtraPayment && !isReferral && viewMode && data.CAD_SITE ?
                    <div class="input-container default Property-info_column_item">
                        <label class="input-label default">CAD Site</label>
                        <div class="view default ">
                            <a href={data.CAD_SITE} target="_blank" rel="noopener noreferrer"
                                className="Property-info-show-notes-btn">
                                Open CAD
                            </a>
                        </div>
                    </div>
                    :
                    !isExtraPayment && !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="CAD_SITE"
                        label="CAD Site"
                        hyperlink={true}
                        value={data.CAD_SITE}
                        disabled={isFieldLocked(locks, "CAD_SITE")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                {
                    !isExtraPayment && !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="ACCOUNT"
                        label="Account #"
                        value={account}
                        disabled={isFieldLocked(locks, "ACCOUNT")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                {
                    !isExtraPayment && !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="integer"
                        name="ASSESSED_VALUE"
                        label="Assessed Value"
                        value={data.ASSESSED_VALUE}
                        disabled={isFieldLocked(locks, "ASSESSED_VALUE")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                }
                {
                    !isExtraPayment && !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="text"
                        name="ASSESSED_YEAR"
                        label="Assessed Year"
                        value={data.ASSESSED_YEAR}
                        disabled={isFieldLocked(locks, "ASSESSED_YEAR")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                {
                    !isExtraPayment && !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        placeholder="MM/DD/YYYY"
                        type="text"
                        valueType="date"
                        name="TRANS_DATE"
                        label="Transaction Date"
                        value={data.TRANS_DATE}
                        disabled={isFieldLocked(locks, "TRANS_DATE")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                }
                {
                    !isExtraPayment && !isReferral &&
                    <Input
                        className="Property-info_column_item"
                        valueType="integer"
                        name="TRANS_PRICE"
                        label="Transaction Price"
                        value={data.TRANS_PRICE}
                        disabled={isFieldLocked(locks, "TRANS_PRICE")}
                        handleParentChange={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                        isDollar
                    />
                }
                {
                    !isExtraPayment && !isReferral &&
                    <Textarea
                        className="Property-info_column_item"
                        theme='white'
                        name='LEGAL_DESC'
                        label='Legal Description'
                        value={data.LEGAL_DESC}
                        maxWidth='100%'
                        viewMode={viewMode}
                        handleParentChange={handleChangeInput}
                    />
                }
                {
                    !isExtraPayment &&
                    <Checkbox
                        text="CORE PROPERTY"
                        type={viewMode || isFieldLocked(locks, "CORE_PROPERTY") ? "uncheckable" : "checkable"}
                        isSelected={data.CORE_PROPERTY === true || data.CORE_PROPERTY === 'y'}
                        handleClick={() => {
                            const on = data.CORE_PROPERTY === true || data.CORE_PROPERTY === 'y';
                            handleChangeInput('CORE_PROPERTY', on ? false : 'y');
                        }}
                        name="CORE_PROPERTY"
                    />
                }
                {
                    !isExtraPayment &&
                    <Checkbox
                        text="NEED INFO"
                        type={viewMode || isFieldLocked(locks, "NEED_INFO") ? "uncheckable" : "checkable"}
                        isSelected={data.NEED_INFO === true || data.NEED_INFO === 'y'}
                        handleClick={() => {
                            const on = data.NEED_INFO === true || data.NEED_INFO === 'y';
                            handleChangeInput('NEED_INFO', on ? false : 'y');
                        }}
                        name="NEED_INFO"
                    />
                }

                {ownDealsOnly && data.SOURCE === "External" && <React.Fragment>
                    <UploadFiles
                    classNames="Property-info_column_item"
                    data={data}
                    viewMode={viewMode}
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    maxFilesAmount={items.length}
                    items={items}
                    canUploadManually
                    handleChangeInput={handleChangeInput}
                />
                </React.Fragment>}
                     <div className="Website_column">
                     {ownDealsOnly && ((data.SOURCE === "SUMMIT" && data.STATUS == "Proposal") || data.SOURCE === "External") && <React.Fragment> 
                        <UploadFiles
                            classNames="Website_column_item"
                            data={data}
                            viewMode={viewMode}
                            deleted={deleted}
                            handleChangeFile={handleChangeFile}
                            maxFilesAmount={photos.length}
                            items={photos}
                            fileType={fileTypes.Photo}

                        /> </React.Fragment>}
                    </div> 

            </div>
            <div className="Property-info_column">
            {
                !isExtraPayment &&
                <Dropdown
                    className="Property-info_column_item"
                    optionKey="code"
                    optionLabelKey="name"
                    data={data}
                    required={ownDealsOnly ? true : false}
                    isFromProperty
                    optionsType="category"
                    value={data.CATEGORY}
                    valueKey="CATEGORY"
                    label="Property Category"
                    disabled={isFieldLocked(locks, "CATEGORY")}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />}
               {data.CATEGORY=='apartments' &&  <div> 
                <Dropdown
                    className="Property-info_column_item"
                    optionKey="code"
                    optionLabelKey="name"
                    data={data}
                    isFromProperty
                    optionsType="subcategory"
                    value={data.SUB_CATEGORY}
                    valueKey="SUB_CATEGORY"
                    label="Sub Category"
                    disabled={isFieldLocked(locks, "SUB_CATEGORY")}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />
             </div>}
                {data.CATEGORY!='apartments' &&  !isExtraPayment && <Dropdown
                    className="Property-info_column_item"
                    optionKey="code"
                    optionLabelKey="name"
                    data={data}
                    isFromProperty
                    optionsType="type"
                    required={ownDealsOnly ? true : false}
                    value={data.TYPE}
                    valueKey="TYPE"
                    label="Property Type"
                    disabled={isFieldLocked(locks, "TYPE")}
                    handleParentChange={handleChangeDropdown}
                    viewMode={viewMode}
                    deleted={deleted}
                />}

                {
                    data.TYPE=== "STNL" && data.CATEGORY!='apartments' && !isReferral && !isExtraPayment &&
                    getTenantSubcategorySTNL({data, handleChangeDropdown, viewMode, deleted, isFromProperty:true, className:"Property-info_column_item"})
                }
                {
                    data.TYPE=== "MT" && data.CATEGORY!='apartments' && !isReferral && !isExtraPayment &&
                    getTenantSubcategoryMT({data, handleChangeDropdown, viewMode, deleted, isFromProperty:true, className:"Property-info_column_item"})
                }
                {
                    isOffMarket &&
                    <React.Fragment>
                        {
                            isFinancing ?
                                <Input
                                    className="Property-info_column_item"
                                    type="text"
                                    valueType="integer"
                                    name="HSC_PRICE"
                                    label="Price"
                                    value={data.HSC_PRICE}
                                    disabled={isFieldLocked(locks, "HSC_PRICE")}
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    isDollar
                                />
                                :
                                <Input
                                    className="Property-info_column_item"
                                    type="text"
                                    valueType="integer"
                                    name="LIST_PRICE"
                                    label="List Price"
                                    value={data.LIST_PRICE}
                                    disabled={isFieldLocked(locks, "LIST_PRICE")}
                                    handleParentChange={handleChangeInput}
                                    viewMode={viewMode}
                                    deleted={deleted}
                                    isDollar
                                />
                        }
                        <Input
                            className="Property-info_column_item"
                            type="text"
                            valueType="percent"
                            name="CAPITALIZATION_RATE"
                            label="Cap Rate"
                            value={data.CAPITALIZATION_RATE}
                            disabled={isFieldLocked(locks, "CAPITALIZATION_RATE")}
                            handleParentChange={handleChangeInput}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                    </React.Fragment>
                }
                {
                    data.TYPE === "STNL" && !isReferral && !isOffMarket && !isExtraPayment && data.CATEGORY!='apartments' &&
                    <React.Fragment>
                        <Dropdown
                            className="Property-info_column_item"
                            data={data}
                            isFromProperty
                            optionsType="lease"
                            value={data.LEASE_TYPE}
                            valueKey="LEASE_TYPE"
                            label="Lease Type"
                            disabled={isFieldLocked(locks, "LEASE_TYPE")}
                            handleParentChange={handleChangeDropdown}
                            viewMode={viewMode}
                            deleted={deleted}
                        />
                        {
                            isSaleLeaseBack && !(data.NAME || '').includes('Christian Brothers Automotive') ?
                                <React.Fragment>
                                    <Input
                                        className="Property-info_column_item"
                                        placeholder="MM/DD/YYYY"
                                        type="text"
                                        name="LEASE_COMMENCEMENT_DATE"
                                        label="Lease Commencement Date"
                                        value={data.CLOSE_OF_ESCROW ? (convertDateTimeFormatToDate(data.CLOSE_OF_ESCROW) || data.CLOSE_OF_ESCROW) : 'At Close of Escrow'}
                                        disabled={true}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                    />
                                    <Input
                                        className="Property-info_column_item"
                                        placeholder="MM/DD/YYYY"
                                        type="text"
                                        name="LEASE_EXPIRATION_DATE"
                                        label="Lease Expiration Date"
                                        value={COE ? COE : `${data.ORIGINAL_LEASE_TERM ? data.ORIGINAL_LEASE_TERM + ' Years from COE': '-'}`}
                                        disabled={true}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                    />
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <Input
                                        className="Property-info_column_item"
                                        placeholder="MM/DD/YYYY"
                                        type="text"
                                        valueType="date"
                                        name="LEASE_COMMENCEMENT_DATE"
                                        label="Lease Commencement Date"
                                        value={data.LEASE_COMMENCEMENT_DATE}
                                        disabled={isSaleLeaseBack}
                                        handleParentChange={handleChangeInput}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                    />
                                    <Input
                                        className="Property-info_column_item"
                                        placeholder="MM/DD/YYYY"
                                        type="text"
                                        valueType="date"
                                        name="LEASE_EXPIRATION_DATE"
                                        label="Lease Expiration Date"
                                        value={data.LEASE_EXPIRATION_DATE}
                                        disabled={isSaleLeaseBack}
                                        handleParentChange={handleChangeInput}
                                        viewMode={viewMode}
                                        deleted={deleted}
                                    />
                                </React.Fragment>
                        }
                    </React.Fragment>
                }
                {
                    data.TYPE === "MT" && !isReferral && !isFinancing && !isOffMarket &&
                    <Tags
                        className="Property-info_column_item"
                        values={getTenantsForTags(data.TENANT_ID).map((el) => el.NAME)}
                        label="Tenant"
                        deleted={deleted}
                    />
                }
                {
                    isFinancing && !isOffMarket &&
                    <UploadFiles
                        classNames="Property-info_column_item"
                        data={data}
                        viewMode={viewMode}
                        deleted={deleted}
                        handleChangeFile={handleChangeFile}
                        maxFilesAmount={items.length}
                        items={items}
                        canUploadManually
                        handleChangeInput={handleChangeInput}
                    />
                }
                {
                    // The button opens Peak Tracking (peak.tracking, which its page needs); the Peak
                    // sections lock hides it too (property.peak_sections).
                    !(locks && locks.hidePeakTracking) && can('peak.tracking', 'view') && (isFinancing || isStriveFinancing) && ['Loan In Process'].includes(data.HSC_STATUS) && !isOffMarket &&
                    <button type='button'
                            className='button-new positive'
                            onClick={redirectToHscTracking}>
                        Tracking
                    </button>
                }
                {showLoanBids && showOnPropertyTab(data) && <LoanBids propertyId={data.ARCIMEDES_ROW_ID} propertyName={data.NAME}/>}
            </div>
        </div>
    );
};

export default PropertyInfo;
